import type { LogisticsState } from "./logistics-types.js";
import { cloneReinforcement } from "./reinforcement-state.js";

export function cloneLogisticsState(state: LogisticsState): LogisticsState {
  return Object.freeze({
    ...state,
    ...(state.reinforcement ? { reinforcement: cloneReinforcement(state.reinforcement) } : {}),
    borders: Object.freeze(
      Object.fromEntries(
        Object.entries(state.borders).map(([id, position]) => [
          id,
          Object.freeze({ ...position, troops: Object.freeze({ ...position.troops }) }),
        ]),
      ),
    ),
    transits: Object.freeze(
      state.transits.map((transit) =>
        Object.freeze({ ...transit, units: Object.freeze({ ...transit.units }) }),
      ),
    ),
    autoReinforce: Object.freeze(
      state.autoReinforce.map((order) =>
        Object.freeze({ ...order, desired: Object.freeze({ ...order.desired }) }),
      ),
    ),
  });
}
